import { PRILStatus, PRILPriority, PRILSource } from "@/constants/request/PRILConstants";
import PortalDictionaryDTO from "@/dto/common/PortalDictionaryDTO";
import PRILComment from "@/dto/request/pril/PRILComment";
import FileMetaDTO from "@/dto/files/FileMetaDTO";
import SublimeEmployeeDTO from "@/dto/sublime/employee/SublimeEmployeeDTO";
import PRILAdditionalFile from "@/dto/request/pril/PRILAdditionalFile";

export type Direction = "INCOMING" | "OUTGOING";
export default class PRIL_DTO {
  id!: number;
  document!: FileMetaDTO;
  customerId!: number;
  customerName!: string;
  status!: PRILStatus;
  assignee: SublimeEmployeeDTO | null = null;
  assigneeId!: number | null;
  assigneeName!: string | null;
  letterDate!: Date;
  sender!: PortalDictionaryDTO;
  source!: PRILSource;
  letterType!: PortalDictionaryDTO;
  createdById!: number;
  createdByName!: string;
  isHidden!: boolean;
  locationId!: number | null;
  locationName!: string | null;
  managerComment!: string | null;
  comments!: Array<PRILComment>;
  priority!: PRILPriority | null;
  dueDate!: Date | null;
  amount!: number | null;
  additionalFiles!: Array<PRILAdditionalFile>;
  direction!: Direction
}
